import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const CompanyIntro = () => {
  const { t } = useLanguage();
  
  return (
    <section id="over-ons" className="bg-white py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-montserrat font-black text-[#e21b1b] text-2xl sm:text-3xl lg:text-4xl mb-10 text-center">
          {t('companyIntro.title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          <p className="font-roboto text-gray-700 text-base sm:text-lg leading-relaxed text-justify">
            {t('companyIntro.paragraph1')}
          </p>
          <p className="font-roboto text-gray-700 text-base sm:text-lg leading-relaxed text-justify">
            {t('companyIntro.paragraph2')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CompanyIntro;
